export enum FontWeight {
  REGULAR = 400,
  MEDIUM = 500,
  BOLD = 700,
}
